import React, { useState } from 'react';
import LaboratoryActivation from './LaboratoryActivation';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import {
	Laboratory,
	LaboratoryWorkplace,
} from '../../../../../graphql/graphql';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	workplaceId: string;
	laboratory: Laboratory;
	onActivationSuccess: () => void;
	workplaceLaboratory?: LaboratoryWorkplace;
}

const LaboratoryActivationModal: React.FC<Props> = props => {
	const [title, setTitle] = useState<string>(
		'component.laboratoryActivationCompanyData.title',
	);

	return (
		<BaseModal {...props} title={title} size={Size.MD}>
			<LaboratoryActivation
				workplaceId={props.workplaceId}
				laboratory={props.laboratory}
				onActivationSuccess={props.onActivationSuccess}
				onStepChange={stepTitle => setTitle(stepTitle)}
				workplaceLaboratory={props.workplaceLaboratory}
			/>
		</BaseModal>
	);
};

export default LaboratoryActivationModal;
